import React from 'react';
import {Button, Card, CardMedia, Typography} from '@mui/material';
import lifeplaceImageMobile from 'presentation/assets/images/lifeplace-image-mobile.webp';
import lifeplaceMobile from 'presentation/assets/images/lifeplace-mobile.svg';
import {Loading} from 'presentation/components/Loading/Loading';

import {translations} from 'presentation/translations-new';
import {BannerProps} from '../types';
import {CardContentStyled} from './styles';
import {useHostName} from 'presentation/hooks';

const {
	lifeplace: {banner},
} = translations['pt-br'].privateFlow.perks;

export const MobileBanner = ({isFetching, handleClick}: BannerProps) => {
	const {isNotredameSaude} = useHostName();
	return (
		<Card elevation={0}>
			<CardMedia component="img" image={lifeplaceImageMobile} alt={banner.imageAlt} />
			<CardContentStyled style={{backgroundImage: `url("${lifeplaceMobile}")`}}>
				<Typography fontSize="18px" fontWeight={700} color="primary" mb={0.5}>
					{banner.title}
				</Typography>

				<Typography variant="body2" color="text.primary">
					{isNotredameSaude
						? banner.description.part1Notredame
						: banner.description.part1Gndi}
					<strong>{banner.description.part2}</strong>
					{banner.description.part3}
				</Typography>

				<Button
					variant="contained"
					size="medium"
					fullWidth
					endIcon={isFetching ? <Loading color="inherit" size={16} /> : null}
					disabled={isFetching}
					onClick={handleClick}
					sx={{mt: 3}}>
					{banner.button}
				</Button>
			</CardContentStyled>
		</Card>
	);
};
